export const styles = {
  arrow: {
    size: "3rem",
    color: "#fff",
  },
  arrow2: {
    size: "1rem",
    color: "rgba(244, 174, 64, 1)",
  },
  social: {
    size: "2rem",
    className: "social-icons",
  },
  socialMenuTop: {
    size: "1rem",
    className: "social-menu-top-icons",
  },
  mobile: {
    size: "2rem",
    color: "#fff",
  },
};
